angular.module('flowingly.runner.print').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state('app.print.flow', {
    url: '/flow',
    template: '<div>Loading</div>',
    controller: 'runnerPrintFlowController',
    controllerAs: '$ctrl'
  });
}
